import { render, staticRenderFns } from "./reversed-tab.vue?vue&type=template&id=3b4db914"
import script from "./reversed-tab.vue?vue&type=script&lang=js"
export * from "./reversed-tab.vue?vue&type=script&lang=js"
import style0 from "./reversed-tab.vue?vue&type=style&index=0&id=3b4db914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports